const GET_STUDENT_LIST_REQUEST = "GET_STUDENT_LIST_REQUEST";
const GET_STUDENT_LIST_COMPLETED = "GET_STUDENT_LIST_COMPLETED";
const GET_STUDENT_LIST_ERROR = "GET_STUDENT_LIST_ERROR";

const GET_STUDENT_PROGRAM_LIST_REQUEST = "GET_STUDENT_PROGRAM_LIST_REQUEST";
const GET_STUDENT_PROGRAM_LIST_COMPLETED = "GET_STUDENT_PROGRAM_LIST_COMPLETED";
const GET_STUDENT_PROGRAM_LIST_ERROR = "GET_STUDENT_PROGRAM_LIST_ERROR";

const ADD_FINAL_ATTACHMENT_COMPLETED = "ADD_FINAL_ATTACHMENT_COMPLETED";
const ADD_FINAL_ATTACHMENT_ERROR = "ADD_FINAL_ATTACHMENT_ERROR";

const DELETE_FINAL_ATTACHMENT_REQUEST = "DELETE_FINAL_ATTACHMENT_REQUEST";
const DELETE_FINAL_ATTACHMENT_COMPLETED = "DELETE_FINAL_ATTACHMENT_COMPLETED";
const DELETE_FINAL_ATTACHMENT_ERROR = "DELETE_FINAL_ATTACHMENT_ERROR";

const CREATE_STUDENT_REQUEST = "CREATE_STUDENT_REQUEST";
const CREATE_STUDENT_COMPLETED = "CREATE_STUDENT_COMPLETED";
const CREATE_STUDENT_ERROR = "CREATE_STUDENT_ERROR";

const UPDATE_STUDENT_REQUEST = "UPDATE_STUDENT_REQUEST";
const UPDATE_STUDENT_COMPLETED = "UPDATE_STUDENT_COMPLETED";
const UPDATE_STUDENT_ERROR = "UPDATE_STUDENT_ERROR";

const IMPORT_SCHOOLCHILDREN_REQUEST = "IMPORT_SCHOOLCHILDREN_REQUEST";
const IMPORT_SCHOOLCHILDREN_COMPLETED = "IMPORT_SCHOOLCHILDREN_COMPLETED";
const IMPORT_SCHOOLCHILDREN_ERROR = "IMPORT_SCHOOLCHILDREN_ERROR";

const DELETE_SCHOOLCHILDREN_REQUEST = "DELETE_SCHOOLCHILDREN_REQUEST";
const DELETE_SCHOOLCHILDREN_COMPLETED = "DELETE_SCHOOLCHILDREN_COMPLETED";
const DELETE_SCHOOLCHILDREN_ERROR = "DELETE_SCHOOLCHILDREN_ERROR";

export default {
  GET_STUDENT_LIST_REQUEST,
  GET_STUDENT_LIST_COMPLETED,
  GET_STUDENT_LIST_ERROR,

  GET_STUDENT_PROGRAM_LIST_REQUEST,
  GET_STUDENT_PROGRAM_LIST_COMPLETED,
  GET_STUDENT_PROGRAM_LIST_ERROR,

  CREATE_STUDENT_REQUEST,
  CREATE_STUDENT_COMPLETED,
  CREATE_STUDENT_ERROR,

  UPDATE_STUDENT_REQUEST,
  UPDATE_STUDENT_COMPLETED,
  UPDATE_STUDENT_ERROR,

  IMPORT_SCHOOLCHILDREN_REQUEST,
  IMPORT_SCHOOLCHILDREN_COMPLETED,
  IMPORT_SCHOOLCHILDREN_ERROR,

  DELETE_SCHOOLCHILDREN_REQUEST,
  DELETE_SCHOOLCHILDREN_COMPLETED,
  DELETE_SCHOOLCHILDREN_ERROR,

  ADD_FINAL_ATTACHMENT_COMPLETED,
  ADD_FINAL_ATTACHMENT_ERROR,

  DELETE_FINAL_ATTACHMENT_REQUEST,
  DELETE_FINAL_ATTACHMENT_COMPLETED,
  DELETE_FINAL_ATTACHMENT_ERROR
}
